var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.375C14 15.1031 14.0806 14.8372 14.2317 14.6111C14.3828 14.385 14.5976 14.2087 14.8488 14.1047C15.1001 14.0006 15.3765 13.9734 15.6432 14.0264C15.91 14.0795 16.155 14.2104 16.3473 14.4027C16.5396 14.595 16.6705 14.84 16.7236 15.1068C16.7766 15.3735 16.7494 15.6499 16.6453 15.9012C16.5413 16.1524 16.365 16.3672 16.1389 16.5183C15.9128 16.6694 15.6469 16.75 15.375 16.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.625C14 2.26033 14.1449 1.91059 14.4027 1.65273C14.6606 1.39487 15.0103 1.25 15.375 1.25C15.7397 1.25 16.0894 1.39487 16.3473 1.65273C16.6051 1.91059 16.75 2.26033 16.75 2.625",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 2.5V15.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 16.75H1.25V2.75H14V15.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 13.75H12.5V7H7.75V8.75H2.75V15.25H7.75V13.75H9.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 11.75V13.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.5H12.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12H6.5",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 8.75V10.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 5.5H2.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 4.25V5.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 4.75V5.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 4.25V5.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M7.75 4.75V5.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 4.75V5.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 4.25V5.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 4.25V5.25",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/plan.b2b4b29b.svg";
export { ForwardRef as ReactComponent };